import { isEmpty } from "lodash";
// redux
import { combineReducers } from "redux";
import { configureStore } from '@reduxjs/toolkit';
// thunk
import { thunk } from "redux-thunk";
// reducers
import CoreReducer from "@/core/reducers";
import CMSReducer from "@/cms/reducers";


const createReducerManager = (initialReducers:any) => {
    const reducers = { ...initialReducers }
    let combinedReducer = combineReducers(reducers)
    let keysToRemove:any[] = []

    return {
        getReducerMap: () => reducers,
        reduce: (state:any, action:any) => {
            if (keysToRemove.length > 0) {
                state = { ...state }
                for (let key of keysToRemove) {
                    delete state[key]
                }
                keysToRemove = []
            }
            return combinedReducer(state, action);
        },
        add: (key:string, reducer:any) => {
            if (!key || reducers[key] || isEmpty(key)) return;
            reducers[key] = reducer;
            combinedReducer = combineReducers(reducers);
        },
        remove: (key:string) => {
            if (!key || !reducers[key]) return;
            delete reducers[key];
            keysToRemove.push(key);
            combinedReducer = combineReducers(reducers);
        }
    }
}

const AppStore = () => {
    const reducerManager = createReducerManager({
        ...CoreReducer,
        ...CMSReducer
    })

    const store:any = configureStore({
        reducer: reducerManager.reduce,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
        devTools: false,
    });

    store.reducerManager = reducerManager;

    return store;
}

export default AppStore();

